import React, {useState} from 'react';
import Navbar from "../components/Navbar";
import HomeSection from "../components/HomeSection";
import AboutMe from "../components/AboutMe";
import ContactMe from "../components/ContactMe";
import Toaster from "../components/Toaster";
import MyWorks from "../components/MyWorks";

const Home = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    }

    return(
        <>
            <Toaster/>
            <Navbar toggle={toggle}/>
            <HomeSection/>
            <AboutMe/>
            <MyWorks/>
            <ContactMe/>
        </>
    )
}

export default Home;
